function sortDeep(value) {
  if (Array.isArray(value)) return value.map(sortDeep);
  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce((acc, key) => {
      acc[key] = sortDeep(value[key]);
      return acc;
    }, {});
  }
  return value;
}

export function buildUiPreferencesPayload({ herdContext = {}, powerUser = {}, basePreferences = {} } = {}) {
  return {
    ...(basePreferences || {}),
    herd_context: {
      ...(basePreferences?.herd_context || {}),
      siteId: herdContext.siteId || '',
      unitId: herdContext.unitId || '',
      baharbandId: herdContext.baharbandId || '',
      scope: herdContext.scope === 'all' ? 'all' : 'active',
      denseMode: typeof herdContext.denseMode === 'boolean' ? herdContext.denseMode : true,
      quickSearch: herdContext.quickSearch || '',
      dateContext: herdContext.dateContext || '',
    },
    power_user: {
      ...(basePreferences?.power_user || {}),
      batchMode: !!powerUser.batchMode,
    },
  };
}

export function getUiPreferenceSnapshot(user) {
  return {
    ...(user?.ui_preferences || {}),
    herdContext: user?.ui_preferences?.herd_context || {},
    powerUser: user?.ui_preferences?.power_user || {},
  };
}

export function stablePreferenceStringify(value) {
  try {
    return JSON.stringify(sortDeep(value ?? null));
  } catch (error) {
    return JSON.stringify(String(value || ''));
  }
}
